import React from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import type { GreeningStatus } from '../../services/greeningApi';

const MESSAGES: Record<string, string> = {
  pending: 'A GreeningAI está na fila para analisar a legislação.',
  processing: 'A GreeningAI está analisando a legislação.',
  retrying: 'A GreeningAI está tentando novamente.',
  failed: 'Não foi possível concluir a análise neste momento.',
  rate_limited: 'Limite de uso diário do contrato atingido.',
  blocked_by_security: 'A pergunta foi bloqueada por segurança por estar fora do escopo do documento.',
  insufficient_context: 'Não há contexto suficiente para responder com segurança.',
};

interface Props {
  status?: GreeningStatus | string;
  userMessage?: string;
  compact?: boolean;
}

const ERROR_STATUSES = new Set(['failed', 'blocked_by_security', 'insufficient_context']);

export function GreeningProcessingStatus({ status, userMessage, compact }: Props) {
  const active = status === 'pending' || status === 'processing' || status === 'retrying';
  const isError = status ? ERROR_STATUSES.has(status) : false;
  const message = userMessage || (status ? MESSAGES[status] : '') || '';

  if (!status && !message) return null;

  if (isError) {
    if (compact) {
      return (
        <Typography variant="caption" color="error">
          {message}
        </Typography>
      );
    }
    return (
      <Alert severity="error" sx={{ py: 1, width: '100%' }}>
        {message}
      </Alert>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: compact ? 0.5 : 1 }}>
      {active && <CircularProgress size={20} />}
      {message && (
        <Typography variant={compact ? 'caption' : 'body2'} color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
}

export default GreeningProcessingStatus;
